import React from 'react';
import heroImage from '../../assets/images/heroImage.png';
import CountUp from 'react-countup';;

const Hero = () => {

  const handleClick = (e) => {
    e.preventDefault();
  
    const targetAttr = e.currentTarget.getAttribute('href');
    const targetElement = document.getElementById(targetAttr.substring(1));
  
    if (targetElement) {
      const location = targetElement.offsetTop;
      window.scrollTo({
        top: location - 80,
        left: 0,
        behavior: 'smooth',
      });
    }
  };  

  return (
    <section className='pt-0' id='about'>
      <div className="container pt-14">
        <div className="md:flex items-center justify-between sm:flex-col md:flex-row">
          <div className="w-full md:basis-1/2">
            <h5 data-aos='fade-right' data-aos-duration='2000' className='text-headingColor font-[600] text-[16px]'>Hola 👋 , Welcome</h5>
            <h1 data-aos='fade-up' data-aos-duration='2000' className='text-headingColor font-[800] text-[1.8rem] sm:text-[40px] leading-[35px] sm:leading-[46px]'>I am Dennis Shakava, <br/> A full-stack Software Dev.</h1>
            <div data-aos='fade-up' data-aos-duration='2300' data-aos-delay='200' className="flex items-center gap-6 mt-7">
              <a href='https://shaki.hashnode.dev/' target='_blank' rel="noreferrer">
                <button className='flex items-center gap-2 text-white font-[600] border border-solid py-2 px-4 rounded-none border-white max-h-[35px] hover:bg-primaryColor hover:text-wite hover:font-[600] ease-in duration-300'><i className="ri-pages-line"></i>Checkout my blog</button>
              </a>
              <a onClick={handleClick} href="#portfolio" rel="noreferrer" className='text-white font-[600] text-[16px] border-b border-solid border-smallTextColor'>Check my work</a>
            </div>
              <p data-aos='fade-left' data-aos-duration='2000' className='flex gap-2 mt-14 text-smallTextColor font-[500] text-[17px] leading-7 sm:pl-14 sm:pr-10'><span><i className="ri-apps-line"></i></span>
                A Full-stack Developer based in Nairobi Kenya , with a focus on creating robust and user friendly web applications.With strong foundation in both front-end and backend development, I specialize in building responsive and scalable solutions that deliver exceptional user experiences.
              </p>
              <div className="gap-9 flex items-center mt-14">
                <span className='text-smallTextColor text-[15px] font-[600]'>Stay in touch
                </span>
                <span className="gap-9 flex items-center">
                  <a href="https://github.com/Shai9" target='_blank' rel="noreferrer" className='text-smallTextColor text-[15px] font-[600]'><i className="ri-github-fill"></i></a>
                  <a href="https://twitter.com/DeeShaki9"  target='_blank' rel="noreferrer" className='text-smallTextColor text-[15px] font-[600]'><i className="ri-twitter-line"></i></a>
                  <a href="https://instagram.com/shaki.dev" target='_blank' rel="noreferrer" className='text-smallTextColor text-[15px] font-[600]'><i className="ri-instagram-line"></i></a>
                  <a href="https://linkdeIn.com/dennis-shakava" target='_blank' rel="noreferrer" className='text-smallTextColor text-[15px] font-[600]'><i className="ri-linkedin-line"></i></a>                
                </span>
              </div>
          </div>
          <div className='basis-1/3 mt-10 sm:mt-0'>
            <figure className='flex items-center justify-center'>
              <img src={heroImage} alt="" />
            </figure>
          </div>
          <div className='md:basis-1/5 flex justify-between text-center mt-10 flex-wrap md:mt-10 md:flex-col md:justify-end md:text-end'>
            <div className="mb-10">
              <p className="text-headingColor font-[700] text-[20px]">
                <CountUp start={0} end={1} duration={2} suffix='+' />
              </p>
              <p className ='text-headingColor font-[700] text-[20px]'>Years of expertise</p>
            </div>
            <div className="mb-10">
              <p className="text-headingColor font-[700] text-[20px]">
                <CountUp start={0} end={100} duration={2} suffix='%' />
              </p>
              <p className ='text-headingColor font-[700] text-[20px]'>Success rate</p>
            </div>
            <div className="mb-10">
              <p className="text-headingColor font-[700] text-[20px]">
                <CountUp start={0} end={30} duration={2} suffix='+' />
              </p>
              <p className ='text-headingColor font-[700] text-[20px]'>Clients</p>
            </div>
            <div className="mb-10">
              <p className="text-headingColor font-[700] text-[20px]">
                <CountUp start={0} end={40} duration={2} suffix='+' />
              </p>
              <p className ='text-headingColor font-[700] text-[20px]'>Projects completed</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero